function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import MdExpandMore from "@meronex/icons/md/MdExpandMore";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ProjectFaq(_ref) {
  var faqs = _ref.faqs,
    config = _ref.config;
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    expandedIndex = _useState2[0],
    setExpandedIndex = _useState2[1];
  var toggleExpand = function toggleExpand(index) {
    setExpandedIndex(expandedIndex === index ? -1 : index);
  };
  if (!faqs || faqs.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col mt-8",
    children: [/*#__PURE__*/_jsx("p", {
      className: " ".concat((config === null || config === void 0 ? void 0 : config.fontTitle) || "", " z-10 text-xl ").concat(config !== null && config !== void 0 && config.darkMode ? "text-primary" : "text-[#130E2F]", " font-bold"),
      children: "Frequently Asked Questions"
    }), /*#__PURE__*/_jsx("div", {
      className: "mt-4 ".concat((config === null || config === void 0 ? void 0 : config.fontBody) || ""),
      children: faqs.map(function (faq, index) {
        return /*#__PURE__*/_jsxs("div", {
          className: "border-b ".concat(config !== null && config !== void 0 && config.darkMode ? "border-gray-600" : "border-gray-300"),
          onClick: function onClick() {
            return toggleExpand(index);
          },
          children: [/*#__PURE__*/_jsxs("button", {
            className: "w-full flex items-center justify-between py-4 px-3 text-left transition-colors ".concat(config !== null && config !== void 0 && config.darkMode ? "hover:bg-gray-800 text-base-content" : "hover:bg-gray-100 text-[#130E2F]"),
            children: [/*#__PURE__*/_jsx("span", {
              className: "font-semibold pr-4",
              children: faq.question
            }), /*#__PURE__*/_jsx(MdExpandMore, {
              className: "flex-shrink-0 transform transition-transform ".concat(expandedIndex === index ? "rotate-180" : ""),
              size: 24
            })]
          }), expandedIndex === index && /*#__PURE__*/_jsx("div", {
            className: "px-3 pb-4 ".concat(config !== null && config !== void 0 && config.darkMode ? "text-base-content" : "text-[#130E2F]"),
            children: /*#__PURE__*/_jsx("p", {
              children: faq.answer
            })
          })]
        }, index);
      })
    })]
  });
}
export default ProjectFaq;